import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { showModal, hideModal } from "store/state/modals/modal";
import { openNotes } from "store/state/note";

import Grid from "@material-ui/core/Grid";
import ListWrapper from "components/Global/List/Wrapper";
import { Toolbar, AppBar, Button } from "@material-ui/core";
import {  createDeal } from "store/state/deal";
import { fetchFunds, createFund, updateFund } from "store/state/fund";
import Funds from "components/Fund";

import { ViewModule, List } from "@material-ui/icons";
import TabButtons from "./TabButtons";
import FundModal from "components/Portfolio/FundModal"
import WhatIfModal from "components/Portfolio/WhatIfModal";

//Widget Tiles
import MetricTile from "components/Global/Metric/MetricTile";
import { getScreenPreferences } from "../../shared-utility/store/state/screenPreferences";
import { getPortfolioMetrics } from "store/state/portfolio";
import styled from "styled-components";

const PaddedDiv = styled.div`
  padding: 0 16px;
`;
const portfolio_view_metric = "portfolio_view_metric";
const sold_deal_table = "sold_deal_table";
const closed_deal_table = "closed_deal_table";

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
});

export const MyContext = React.createContext({
  fundModalEdit: () => {},
});

const emptyFund = {
  name: "",
  description: "",
  inceptionDate: ""
}

class Portfolio extends Component {
  state = {
    isNewFundModalOpen: false,
    isFundModalEdit: false,
    newDealVisible: false,
    tooltip_show: false,
    view: "list",
    value: 0,
    initialFundValues: emptyFund,
    isWhatIfModalOpen: false,
  };

  componentDidMount() {
    this.props.getScreenPreferences({
      screenType: portfolio_view_metric
    });
    this.props.getScreenPreferences({
      screenType: sold_deal_table
    });
    this.props.getScreenPreferences({
      screenType: closed_deal_table
    });
    //This should not pass an ID in the payload. It should take the companyId from the user accessing the metrics
    this.props.getPortfolioMetrics(); 
  }

  onOpenFundModal = () => {
    this.setState({
      currentFundId: undefined,
      initialFundValues: emptyFund,
      isFundModalEdit: false,
      isNewFundModalOpen: true,
    });
  };

  onOpenWhatIfModal = () => {
    this.setState({
      isWhatIfModalOpen: true,
    });
  };

  closeWhatIfModal = () => {
    this.setState({
      isWhatIfModalOpen: false,
    });
  }

  closeFundModal = () => {
    this.setState({
      isNewFundModalOpen: false,
    });
  };

  fundModalEdit = fundId => {
    this.setState({
      isNewFundModalOpen: true,
      isFundModalEdit: true,
      currentFundId: fundId,
    });
  };

  updateInitialFundValues = funds => {
    this.setState({
      initialFundValues: funds[this.state.currentFundId]
    });
  };

  toggleNewDeal = () => this.props.showModal("New Deal");

  createFund = values => {
    this.props.createFund({
      fund: {
        ...values
      }
    });
  };

  updateFund = values => {
    this.props.updateFund({
      ...values
    });
  };

  createDeal = values => {
    this.props.history.push(`/newdeal`);
  };

  navigateToFund = fundId => {
    if (fundId !== "none") {
      this.props.history.push(`/funds/${fundId}`);
    } else {
      this.props.history.push(`/portfolio`);
    }
  };

  listView = () => {
    this.setState({ view: "list" });
  };

  tileView = () => {
    this.setState({ view: "tile" });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { isNewFundModalOpen, isFundModalEdit, value } = this.state;
    const { screen_pref, metricData, classes, fund, loading} = this.props;
    const funds = fund.funds;
    const allFunds = fund.all;

    if (this.state.initialFundValues !== funds[this.state.currentFundId]) {
      this.updateInitialFundValues(funds)
    }
    
    let fundNameList = [];
    for(const key in allFunds) {
      fundNameList.push((allFunds[key].name).toLowerCase());
    }
    
    return (
      <Fragment>
        <PaddedDiv>
          <h3>Portfolio Summary</h3>
          <MetricTile
            screenType={portfolio_view_metric}
            tileData={screen_pref}
            metricData={metricData}
          />
          {/* <WhatIfModal 
            isOpen = {this.state.isWhatIfModalOpen}
            handleClose = {this.closeWhatIfModal}
            scope = {"portfolio"}
            /> */}
          <Grid container spacing={24} style={{ paddingTop: 16 }}>
            <ListWrapper
              buttonProps={{ onClick: this.onOpenFundModal, label: "New Group", id:"newFundButton"}}
              // buttonPropsLeft={{ 
              //   onClick: this.onOpenWhatIfModal,
              //   label: "What If",
              //   id:"whatIfButton"}}
            >
             <MyContext.Provider value={{
               fundModalEdit: (fundId) => { this.fundModalEdit(fundId) }
             }}>
              <Funds 
                onOpenFundModal={this.onOpenFundModal}
              />
              </MyContext.Provider>
            </ListWrapper>
            <ListWrapper>
              <TabButtons createDeal={this.createDeal} />
            </ListWrapper>
          </Grid>
          <FundModal
            isOpen={isNewFundModalOpen}
            isEdit={isFundModalEdit}
            onSave={this.createFund}
            updateFund={this.updateFund}
            onClose={this.closeFundModal}
            fundNameList={fundNameList}
            fund={this.state.initialFundValues}
            authentication={this.props.authentication}
          />
        </PaddedDiv>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  authentication,
  portfolio,
  fund,
  deal,
  screenPreferences,
  loading
}) => ({
  authentication,
  fund,
  deal,
  screen_pref: screenPreferences.screen_pref.portfolio_view_metric || null,
  metricData: portfolio.metricData,
  loading
});

export default compose(
  connect(
    mapStateToProps,
    {      
      fetchFunds,
      createFund,
      updateFund,
      createDeal,
      showModal,
      hideModal,
      openNotes,
      getScreenPreferences,
      getPortfolioMetrics
    }
  ),
  withStyles(styles)
)(Portfolio);
